/**
 * Created by Administrador on 06/05/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('flightTrackingService',flightTrackingService);

    flightTrackingService.$inject = ['$http', 'CONFIG','messageService'];

    function flightTrackingService($http, CONFIG, messageService){

        var urlFlights = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/flights';
        var urlConnections = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/connections';
        var urlAuditLogReports = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/audit-log-reports';
        var urlAuditLog = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/audit-logs';

        var service = {
            getFlightsByFlightId: getFlightsByFlightId,
            getFlightNumbersByFlightConnections: getFlightNumbersByFlightConnections,
            getFlightsByFlight: getFlightsByFlight,
            getFlightsByFlightAll: getFlightsByFlightAll,
            getFlightsByConnection: getFlightsByConnection,
            getFlightsByConnectionAll: getFlightsByConnectionAll,
            getRevenueAdministration: getRevenueAdministration,
            getAuditLogById: getAuditLogById
        };

        return service;

        function getFlightsByFlightId(flights, flightId) {
            var result = flights.filter(function(flight) {
                return flight.flightId === flightId;
            });
            return result.length > 0 ? result[0] : null;
        }

        function getFlightNumbersByFlightConnections(departureFlightConnections) {
            var flightNumbers = '';
            for (var i = 0; i < departureFlightConnections.length; i++) {
                var currentNumber = departureFlightConnections[i]._embedded.flight.flightNumber;
                if (flightNumbers === '') {
                    flightNumbers = currentNumber;
                } else {
                    flightNumbers += ' - ' + currentNumber;
                }
            }
            return flightNumbers;
        }

        function getFlightsByFlight(date){
            return $http.get(urlFlights + '/dateSearch/' + date )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getFlightsByFlightAll(date){
            return $http.get(urlFlights + '/all-dateSearch/' + date )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getFlightsByConnection(date){
            return $http.get(urlConnections + '/' + date )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getFlightsByConnectionAll(date){
            return $http.get(urlConnections + '/all/' + date )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getRevenueAdministration(page, size, flightIdConnectionId , status, isFlight){
            return $http.get(urlAuditLogReports +'/revenue-administration?' + 'flightIdConnectionId=' + flightIdConnectionId  + '&status=' + status + '&isFlight=' + isFlight + '&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAuditLogById(id) {
            return $http.get(urlAuditLog +'/' + id)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }
    }
})();
